// @flow
import React from 'react'
import i18n from 'i18next'
import Link from '../../../../Link'
import ArrowIcon from '../../../../icons/ArrowIcon'
import {
  PanelWrapper,
  PanelHeader,
  PanelBody,
  PanelList,
  PanelItem,
  IconWrapper
} from '../styles'

const CATEGORY_INFO = 'info'
const TRANSITION_ACTIVE_DELAY = 100

type Props = {
  activeCategory: string,
  onCategoryClick: Function,
  links: Array<Object>,
  staticPageID: string
}

type State = {
  panelBodyHeight: number,
  panelBodyTransition: boolean
}

class InfoPanel extends React.Component<Props, State> {
  panelListRef = React.createRef()
  transitionTimeout = null

  state = {
    panelBodyHeight: 0,
    panelBodyTransition: false
  }

  componentDidMount () {
    if (this.panelListRef.current) {
      const panelBodyHeight = this.panelListRef.current.clientHeight
      this.setState({ panelBodyHeight })
      this.transitionTimeout = this.addPanelBodyTransition()
    }
  }

  componentWillUnmount () {
    if (this.transitionTimeout) {
      clearTimeout(this.transitionTimeout)
    }
  }

  isCategoryActive () {
    return CATEGORY_INFO === this.props.activeCategory
  }

  getPanelBodyHeight () {
    return this.isCategoryActive() ? this.state.panelBodyHeight : 0
  }

  addPanelBodyTransition = () =>
    setTimeout(() => {
      this.setState({ panelBodyTransition: true })
    }, TRANSITION_ACTIVE_DELAY)

  render () {
    return (
      <PanelWrapper>
        <PanelHeader onClick={() => this.props.onCategoryClick(CATEGORY_INFO)}>
          <IconWrapper isActive={this.isCategoryActive()}>
            <ArrowIcon />
          </IconWrapper>
          <p>+Info</p>
        </PanelHeader>
        <PanelBody
          height={this.getPanelBodyHeight()}
          isTransitionActive={this.state.panelBodyTransition}
        >
          <PanelList ref={this.panelListRef}>
            {this.props.links.map((link, index) => {
              return (
                <PanelItem
                  key={index}
                  active={this.props.staticPageID === link.pageSlug}
                >
                  {link.target === '_blank' ? (
                    <a href={i18n.t(link.link)} target={link.target}>
                      <p>{i18n.t(link.text)}</p>
                    </a>
                  ) : (
                    <Link to={i18n.t(link.link)}>
                      <p>{i18n.t(link.text)}</p>
                    </Link>
                  )}
                </PanelItem>
              )
            })}
          </PanelList>
        </PanelBody>
      </PanelWrapper>
    )
  }
}

export default InfoPanel
